import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    fill(event) {
        const content = event.currentTarget.dataset.content
        const form = document.querySelector("#new_message")
        const input = form?.querySelector("input[name='message[content]']")
        if (input && form) {
            input.value = content
            form.requestSubmit()
        }
    }
}
